import { IconButton, IconButtonProps } from "@mui/material";

import SeeIcon from "@assets/see_icon.svg";
import ExcelIcon from "@assets/excel_icon.svg";
import EditIcon from "@mui/icons-material/Edit";
import RejectIcon from "@assets/reject_icon.svg";
import ClearIcon from "@mui/icons-material/Clear";
import CachedIcon from "@mui/icons-material/Cached";
import ValidateIcon from "@assets/validate_icon.svg";
import DownloadIcon from "@assets/download_icon.svg";
import UploadIcon from "@assets/upload_blue_icon.svg";
import EditNoteIcon from "@mui/icons-material/EditNote";
import RejectedIcon from "@assets/reject_enable_icon.svg";
import ValidatedIcon from "@assets/validate_enable_icon.svg";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import SaveIcon from "@mui/icons-material/Save";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddBoxIcon from "@mui/icons-material/AddBox";
import LogoutIcon from "@mui/icons-material/Logout";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

export enum ActionIconType {
    SEE,
    DOWNLOAD,
    UPLOAD,
    RELOAD,
    REJECT,
    VALIDATE,
    REJECTED,
    VALIDATED,
    EDITION,
    DELETE,
    EDIT_ONE,
    TOGGLE_ON,
    TOGGLE_OFF,
    SAVE,
    EDIT_EYE,
    CANCEL,
    COPY,
    CALC_FILE,
    STATUS_VALIDATED,
    STATUS_REJECTED,
    STATUS_DEFAULT,
    ADD,
    LOGOUT,
    PERMISSIONS,
    NONE,
}

interface ActionIconProps extends IconButtonProps {
    typeIcon: ActionIconType;
}

export const ActionIcon = (props: ActionIconProps) => {
    const { typeIcon, ...others } = props;

    const getIcon = () => {
        switch (typeIcon) {
            case ActionIconType.SEE:
                return <VisibilityOutlinedIcon color="main4" />;
            case ActionIconType.DOWNLOAD:
                return <img src={DownloadIcon} />;
            case ActionIconType.UPLOAD:
                return <img src={UploadIcon} />;
            case ActionIconType.RELOAD:
                return <CachedIcon />;
            case ActionIconType.REJECT:
                return <img src={RejectIcon} />;
            case ActionIconType.VALIDATE:
                return <img src={ValidateIcon} />;
            case ActionIconType.REJECTED:
                return <img src={RejectedIcon} />;
            case ActionIconType.VALIDATED:
                return <img src={ValidatedIcon} />;
            case ActionIconType.EDITION:
                return <EditNoteIcon />;
            case ActionIconType.DELETE:
                return <DeleteForeverIcon />;
            case ActionIconType.EDIT_ONE:
                return <EditIcon />;
            case ActionIconType.TOGGLE_ON:
                return <ToggleOnIcon />;
            case ActionIconType.TOGGLE_OFF:
                return <ToggleOffIcon />;
            case ActionIconType.SAVE:
                return <SaveIcon />;
            case ActionIconType.EDIT_EYE:
                return <VisibilityOutlinedIcon color="main2" />;
            case ActionIconType.CANCEL:
                return <ClearIcon />;
            case ActionIconType.COPY:
                return <ContentCopyIcon />;
            case ActionIconType.CALC_FILE:
                return <img src={ExcelIcon} />;
            case ActionIconType.STATUS_VALIDATED:
                return <CancelIcon color="secondary3" />;
            case ActionIconType.STATUS_REJECTED:
                return <CheckCircleIcon color="secondary4" />;
            case ActionIconType.STATUS_DEFAULT:
                return <RemoveCircleIcon />;
            case ActionIconType.ADD:
                return <AddBoxIcon />;
            case ActionIconType.LOGOUT:
                return <LogoutIcon />;
            case ActionIconType.PERMISSIONS:
                return <AdminPanelSettingsIcon />;
            case ActionIconType.NONE:
                return <></>;
        }
    };

    return <IconButton {...others}>{getIcon()}</IconButton>;
};
